import type { Order, OrderStatus, PaymentStatus } from '@vastra/types';

/** True when a return or exchange request on this order was fully processed. */
export function hasProcessedReturnExchange(order: Order): boolean {
  return order.returnExchangeSummaries?.some(
    (s) => s.status === 'processed'
  ) ?? false;
}

/**
 * Order status for admin/customer UI. Older API versions left `status`/`paymentStatus` unchanged
 * after a processed return or exchange; this maps those rows to Returned/Exchanged for display.
 */
export function displayOrderStatusForUi(order: Order): OrderStatus {
  if (!hasProcessedReturnExchange(order)) return order.status;
  if (order.status === 'Cancelled' || order.status === 'Failed') return order.status;
  
  // Check if this is an exchange (has a replacement order) or a return
  const hasExchange = order.returnExchangeSummaries?.some((s) => s.kind === 'exchange' && s.status === 'processed') ?? false;
  
  if (hasExchange) return 'Exchanged';
  return 'Returned';
}

/**
 * Payment status for UI when legacy rows still have `Completed` after a processed return refund.
 */
export function displayPaymentStatusForUi(order: Order): PaymentStatus {
  if (hasProcessedReturnExchange(order) && order.paymentStatus === 'Completed') return 'Refunded';
  return order.paymentStatus;
}
